/// ----------------------------------------------------------------------------------------
///Copyright (C) 2016 to the present, Crestron Electronics, Inc.
///All rights reserved.
///No part of this software may be reproduced in any form, machine
///or natural, without the express written consent of Crestron Electronics.
/// ----------------------------------------------------------------------------------------
/// <file>
/// <name>authguard.service.ts</name>
///
/// <description>
///  
///  
///  
/// </description>
///
/// <author>Scott Grau</author>
/// <created>11 Jan 2017</created>
///
/// <changelog>
///   Date  Who Version     Flag Comments
/// ======= === =========== ==== ===========================================================
/// 11Jan2017  1.0.0000         First cut 
/// </changelog>
///
/// </file>
/// ----------------------------------------------------------------------------------------
import { Injectable }     from '@angular/core';
import {  Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot }    from '@angular/router';
import { AuthorizationService } from './authorization.service';
import { Observable } from 'rxjs/Observable';


@Injectable()
export class AuthGuardAccountsTab implements CanActivate {
  constructor(  private router: Router,
                private authorizationService: AuthorizationService
            ) { }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<any> {   
    console.log("*****************************AuthGuardAccountsTab Called ********************"); 
    console.log("route URL " + route.url.toString() );    
    return(this.authorizationService.isAuthorized("AccountsTab").toPromise());
  }
}

@Injectable()
export class AuthGuardSettingsTab implements CanActivate {
  constructor(  private router: Router,
                private authorizationService: AuthorizationService
            ) { }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<any> {   
      console.log("*****************************AuthGuardSettingsTab Called ********************"); 
    console.log("route URL " + route.url.toString() );    
    return(this.authorizationService.isAuthorized("SettingsTab").toPromise());
  } 
}

@Injectable()
export class AuthGuardUsersTab implements CanActivate {
    constructor(private router: Router,
        private authorizationService: AuthorizationService
    ) { }
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<any> {
        console.log("*****************************AuthGuardUsersTab Called ********************");
        console.log("route URL " + route.url.toString());
        return (this.authorizationService.isAuthorized("UsersTab").toPromise());
    }
}

@Injectable()
export class AuthGuardCrestronUsersTab implements CanActivate {
  constructor(  private router: Router,
                private authorizationService: AuthorizationService
            ) { }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<any> {   
    console.log("*****************************AuthGuardCrestronUsersTab Called ********************"); 
    console.log("route URL " + route.url.toString() );    
    return(this.authorizationService.isAuthorized("CrestronUsersTab").toPromise());
  } 
}

@Injectable()
export class AuthGuardCrestronDevicesTab implements CanActivate {
  constructor(  private router: Router,
                private authorizationService: AuthorizationService
            ) { }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<any> {   
    console.log("*****************************AuthGuardCrestronDevicesTab Called ********************"); 
    console.log("route URL " + route.url.toString() );    
    return(this.authorizationService.isAuthorized("DevicesTab").toPromise());
  } 
}

@Injectable()
export class AuthGuardViewSupportLogsCustomerAccount implements CanActivate {
  constructor(  private router: Router,
                private authorizationService: AuthorizationService
            ) { }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<any> {   
    console.log("*****************************AuthGuardViewSupportLogsCustomerAccount Called ********************"); 
    console.log("route URL " + route.url.toString() );
    
    return(this.authorizationService.isAuthorized("ViewSupportLogsCustomerAccount").toPromise());
  } 
}

@Injectable()
export class AuthGuardAddCreateNewAccounts implements CanActivate {
  constructor(  private router: Router,
                private authorizationService: AuthorizationService
            ) { }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<any> {   
    console.log("*****************************AuthGuardAddCreateNewAccounts Called ********************"); 
    console.log("route URL " + route.url.toString() );
     
    return(this.authorizationService.isAuthorized("AddCreateNewAccounts").toPromise());
  } 
  

}
@Injectable()
  export class AuthGuardChangeAccountSettings implements CanActivate {
  constructor(  private router: Router,
                private authorizationService: AuthorizationService
            ) { }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<any> {   
    console.log("*****************************AuthGuardChangeAccountSettings Called ********************"); 
    console.log("route URL " + route.url.toString() );
      
     return(this.authorizationService.isAuthorized("ChangeAccountSettings").toPromise());
  } 

  
 }

 @Injectable()
  export class AuthGuardAddRemoveUsers implements CanActivate {
  constructor(  private router: Router,
                private authorizationService: AuthorizationService
            ) { }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<any> {   
      console.log("*****************************AuthGuardAddRemoveUsers Called ********************"); 
      console.log("route URL " + route.url.toString() );
       
       return(this.authorizationService.isAuthorized("AddRemoveUsers").toPromise());
    } 
  }
  @Injectable()
    export class AuthGuardViewLicenses implements CanActivate {
    constructor(  private router: Router,
                  private authorizationService: AuthorizationService
              ) { }
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<any> {   
      console.log("*****************************AuthGuardViewLicenses Called ********************"); 
      console.log("route URL " + route.url.toString() );
      
      return(this.authorizationService.isAuthorized("ViewLicenses").toPromise());
    } 
  }

   @Injectable()
    export class AuthGuardViewDeviceStatus implements CanActivate {
    constructor(  private router: Router,
                  private authorizationService: AuthorizationService
              ) { }
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<any> {   
      console.log("*****************************ViewDeviceStatus Called ********************"); 
      console.log("route URL " + route.url.toString() );
      
      return(this.authorizationService.isAuthorized("ViewDeviceStatus").toPromise());
    } 
  }

@Injectable()
export class AuthGuardPortalManagementTab implements CanActivate {
    constructor(private router: Router,
        private authorizationService: AuthorizationService
    ) { }
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<any> {
        console.log("*****************************AuthGuardPortalManagementTab Called ********************");
        console.log("route URL " + route.url.toString());
        return (this.authorizationService.isAuthorized("PortalManagementTab").toPromise());
    }
}

@Injectable()
export class AuthGuardFileUploadTab implements CanActivate {
    constructor(private router: Router,
        private authorizationService: AuthorizationService
    ) { }
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<any> {
        console.log("*****************************AuthGuardFileTab Called ********************");
        console.log("route URL " + route.url.toString());
        return (this.authorizationService.isAuthorized("FileTab").toPromise());
    }

}






// WEBPACK FOOTER //
// C:/WS/Fusion/FusionDashboard/src/app/authorization/shared/authguard.service.ts